import { Component, Host, h, Element } from '@stencil/core';

export interface AhaCarouselItem extends HTMLAhaCarouselItemElement {}

/**
 * The `aha-carousel-item` component is meant to be used inside `aha-carousel`, and functions as the container for the content of each slide.
 * @slot default - Contents of the `aha-carousel-item`.
 */
@Component({
  tag: 'aha-carousel-item',
  styleUrl: 'aha-carousel-item.css',
  shadow: true,
})
export class AhaCarouselItem {
  @Element() host!: HTMLAhaCarouselItemElement;
  render() {
    return (
      <Host>
        <slot name="header"></slot>
        <div id="content">
          <slot></slot>
        </div>
      </Host>
    );
  }
}
